// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GuestPage_wrapper__3UuD-","btn":"GuestPage_btn__1Gaf4"};